import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { IdleWarning } from "@/components/IdleWarning";
import Login from "@/pages/Login";
import Scrubber from "@/pages/Scrubber";
import AdminUsers from "@/pages/AdminUsers";
import ChangePassword from "@/pages/ChangePassword";
import InviteAccept from "@/pages/InviteAccept";
import Restore from "@/pages/Restore";
import Guide from "@/pages/Guide";

function Shell() {
  const { user } = useAuth();
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/invite/:token" element={<InviteAccept />} />
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
        <Route path="/" element={<ProtectedRoute><Scrubber /></ProtectedRoute>} />
        <Route path="/restore" element={<ProtectedRoute><Restore /></ProtectedRoute>} />
        <Route path="/guide" element={<ProtectedRoute><Guide /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
      </Routes>
      {user && <IdleWarning />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
